/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decide per task. Keep a short list of what passed, what needs a workaround and what failed. Repeat the relevant checks after upgrading the software.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_3 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按具体任务作出决定，简要记录哪些通过、哪些需要替代操作、哪些未通过。软件升级后重新检查相关项目。`)
};

/**
* | output |
* | --- |
* | "Decide per task. Keep a short list of what passed, what needs a workaround and what failed. Repeat the relevant checks after upgrading the software." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_3_steps_3 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_3_Steps_3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_3_steps_3(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_3_steps_3(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_3_steps_3 as "gc.search_guides.gridcraft_vs_excel.sections.3.steps.3" }